import { Injectable } from "@angular/core";
import { Configuration } from "@content-platform/web-angular-shared-util-configuration";
import * as i0 from "@angular/core";
export class NewRelicNewService {
    constructor() {
        this.isLoaderInjected = false;
    }
    loadNewRelicAgent(newRelicConfig) {
        // Update New Relic secrets in config
        const updated = Configuration.updateNewRelicConfig(newRelicConfig);
        if (updated) {
            // Load New Relic scripts
            this.loadScripts();
        }
    }
    loadScripts() {
        if (this.isLoaderInjected) {
            console.log("ℹ️ New Relic scripts already loaded, skipping...");
            return;
        }
        // NR loader script
        const nrLoader = document.createElement("script");
        nrLoader.src = "https://js-agent.newrelic.com/nr-loader-spa-1.258.1.min.js";
        nrLoader.type = "text/javascript";
        nrLoader.async = true;
        nrLoader.onload = () => {
            console.log("✅ New Relic loader loaded");
        };
        document.head.appendChild(nrLoader);
        this.isLoaderInjected = true;
    }
    static { this.ɵfac = function NewRelicNewService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NewRelicNewService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NewRelicNewService, factory: NewRelicNewService.ɵfac, providedIn: "root" }); }
}
//# sourceMappingURL=new-relic-new.service.js.map